<template>
  <div id="preferentialSettings" v-if="childRetrieve != '0'">
    <div>
      <div style="font-size: 15px;color: #333333;display: flex;margin-top: 20px;margin-bottom: 20px;">
        全平台下满减优惠设置
      </div>
      <el-radio v-model="reducedCalculate" label="0" @change="updatereducedCalculate()">满一件</el-radio>
      <el-radio v-model="reducedCalculate" label="1" @change="updatereducedCalculate()">满N件（包含一件）</el-radio>
      <div style="font-size: 15px;color: #333333;display: flex;margin-top: 20px;margin-bottom: 20px;">
        1药城分类配置
      </div>
      <el-radio v-model="categoryManagement" label="0" @change="updatecategoryManagement()">药品</el-radio>
      <el-radio v-model="categoryManagement" label="1" @change="updatecategoryManagement()">医疗器械 </el-radio>
      <el-radio v-model="categoryManagement" label="2" @change="updatecategoryManagement()">保健食品</el-radio>
      <el-radio v-model="categoryManagement" label="3" @change="updatecategoryManagement()">中药</el-radio>
      <el-radio v-model="categoryManagement" label="4" @change="updatecategoryManagement()">食品</el-radio>
      <el-radio v-model="categoryManagement" label="5" @change="updatecategoryManagement()">个人护理</el-radio>
      <div style="font-size: 15px;color: #333333;display: flex;margin-top: 20px;">
        请选择参与到手价计算的优惠券类型
      </div>
      <div v-for="item in platformData" style="font-size: 14px;">
        <div class="titleStyle">
          {{item.platform}}
        </div>
        <el-checkbox-group v-model="checkList" v-for="n in item.data" @change="checkboxChange()">
          <el-checkbox :label="n.type" style="margin-right: 20px;margin-left: 20px;">
            {{n.name}}
            <el-tooltip class="item" effect="dark" :content="n.title" placement="top">
              <i class="el-icon-warning-outline" v-if="n.title" ></i>
            </el-tooltip>
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from "axios";
  export default {
    name:"preferentialSettings",
    props: {
      childRetrieve:String
    },
    data(){
      return{
        reducedCalculate: '0',
        categoryManagement: '0',
        checkList: [],
        platformData: [{
          platform: '淘宝天猫',
          data:[{
            name: '店铺优惠券',
            num: 1,
            type: 'tbtm1'
          },{
            name: '店铺活动',
            num: 2,
            type: 'tbtm2'
          },{
            name: '预售',
            title: '一般为付定金可优惠XX元',
            num: 3,
            type: 'tbtm3'
          },{
            name: '跨店满减',
            title: '包含满减与每满减',
            num: 5,
            type: 'tbtm5'
          },{
            name: '商品优惠券',
            num: 6,
            type: 'tbtm6'
          },{
            name: '淘客券',
            title: '淘宝/天猫店铺发布的优惠券，一般不在页面上显示',
            num: 7,
            type: 'tbtm7'
          },{
            name: '品类购物劵',
            title: '淘宝/天猫平台不定期发布的特殊优惠券，一般是某些品类的商品可用',
            num: 8,
            type: 'tbtm8'
          },{
            name: '官方立减',
            num: 9,
            type: 'tbtm9'
          }]
        },{
          platform: '京东',
          data:[{
            name: '优惠券',
            num: 6,
            type: 'jd6'
          },{
            name: '店铺活动',
            num: 2,
            type: 'jd2'
          },{
            name: '跨店满减',
            title: '包含满减与每满减',
            num: 5,
            type: 'jd5'
          },{
            name: '预售',
            title: '一般为付定金可优惠XX元',
            num: 3,
            type: 'jd3'
          }]
        },{
          platform: '苏宁',
          data:[{
            name: '优惠券',
            num: 6,
            type: 'sn6'
          },{
            name: '店铺活动',
            num: 2,
            type: 'sn2'
          },{
            name: '跨店满减',
            title: '包含满减与每满减',
            num: 5,
            type: 'sn5'
          },{
            name: '预售',
            title: '一般为付定金可优惠XX元',
            num: 3,
            type: 'sn3'
          }]
        },{
          platform: '拼多多',
          data:[{
            name: '店铺优惠券',
            num: 2,
            type: 'pdd2'
          },{
            name: '商品优惠券',
            num: 3,
            type: 'pdd3'
          },{
            name: '关注店铺劵',
            title: '拼多多店铺发布的需要关注店铺才可用的优惠券，一般为无门槛',
            num: 5,
            type: 'pdd5'
          },{
            name: '店铺活动劵',
            num: 9,
            type: 'pdd9'
          }]
        },{
          platform: '当当',
          data:[{
            name: '领券',
            num: 6,
            type: 'dd6'
          },{
            name: '店铺促销',
            num: 1,
            type: 'dd1'
          },{
            name: '满额减',
            // title: '拼多多店铺发布的需要关注店铺才可用的优惠券，一般为无门槛',
            num: 5,
            type: 'dd5'
          },{
            name: '满N件折',
            // title: '拼多多店铺发布的需要关注店铺才可用的优惠券，一般为无门槛',
            num: 9,
            type: 'dd9'
          }]
        },{
            platform: '唯品会',
            data:[{
              name: '领券',
              num: 6,
              type: 'wph6'
            },{
              name: '店铺促销',
              num: 1,
              type: 'wph1'
            },{
              name: '满额减',
              num: 5,
              type: 'wph5'
            },{
              name: '满N件折',
              num: 9,
              type: 'wph9'
            }]
        },{
            platform: '药房网',
            data:[{
              name: '优惠券',
              num: 6,
              type: 'yfw6'
            }]
        },{
            platform: '1药城',
            data:[{
              name: '店铺优惠券',
              num: 1,
              type: 'yyc1'
            },{
              name: '商品优惠券',
              num: 6,
              type: 'yyc6'
            },{
              name: '店铺活动',
              num: 2,
              type: 'yyc2'
            }]
        }],
        taobao: [],
        jingdong: [],
        pinduoduo: [],
        suning: [],
        dangdang: [],
        weipinhui: [],
        yaofangwang: [],
        yiyaocheng: [],
      }
    },
    mounted() {
      this.selectbmcSetting()
    },
    methods:{
      updatereducedCalculate() {
        let params = {
          reducedCalculate: Number(this.reducedCalculate)
        }
        fetch({
          url: "hcm/cus/updatereducedCalculate",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: '保存成功',
              type: 'success'
            });
            this.selectbmcSetting()
          } else {
            this.$message.error(response.data.message)
          }
        }).catch(err => {
          // this.$message.error('接口异常');
          this.selectbmcSetting()
        });
      },
      updatecategoryManagement() {
        let params = {
          categoryManagement: this.categoryManagement
        }
        fetch({
          url: "hcm/cus/updatecategoryManagement",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: '保存成功',
              type: 'success'
            });
            this.selectbmcSetting()
          } else {
            this.$message.error(response.data.message)
          }
        }).catch(err => {
          this.selectbmcSetting()
        });
      },
      // 获取品牌方相关设置
      selectbmcSetting() {
        fetch({
          url: "/hcm/cus/selectbmcSetting",
          method: "get",
          // params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            var tbArr = []
            var jdArr = []
            var snArr = []
            var pddArr = []
            var ddArr = []
            var wphArr = []
            var yfwArr = []
            var yycArr = []


            this.checkList = []
            // 淘宝优惠券回显
            if (res.data.taobao) {
              tbArr = res.data.taobao.split(",")
              for (var i = 0; i < this.platformData[0].data.length; i++) {
                for (var a = 0; a < tbArr.length; a++) {
                  if (this.platformData[0].data[i].num == tbArr[a]) {
                    this.checkList.push('tbtm' + tbArr[a])
                  }
                }
              }
            }
            // 京东优惠券回显
            if (res.data.jingdong) {
              jdArr = res.data.jingdong.split(",")
              for (var i = 0; i < this.platformData[1].data.length; i++) {
                for (var a = 0; a < jdArr.length; a++) {
                  if (this.platformData[1].data[i].num == jdArr[a]) {
                    this.checkList.push('jd' + jdArr[a])
                  }
                }
              }
            }
            // 苏宁优惠券回显
            if (res.data.suning) {
              snArr = res.data.suning.split(",")
              for (var i = 0; i < this.platformData[2].data.length; i++) {
                for (var a = 0; a < snArr.length; a++) {
                  if (this.platformData[2].data[i].num == snArr[a]) {
                    this.checkList.push('sn' + snArr[a])
                  }
                }
              }
            }
            // 拼多多优惠券回显
            if (res.data.pinduoduo) {
              pddArr = res.data.pinduoduo.split(",")
              for (var i = 0; i < this.platformData[3].data.length; i++) {
                for (var a = 0; a < pddArr.length; a++) {
                  if (this.platformData[3].data[i].num == pddArr[a]) {
                    this.checkList.push('pdd' + pddArr[a])
                  }
                }
              }
            }
            // 当当优惠券回显
            if (res.data.dangdang) {
              let ddArr2 = []
              ddArr = res.data.dangdang.split(",")
              if (ddArr.length > 0) {
                for (let a in ddArr) {
                  if (ddArr[a]) {
                    ddArr2.push(ddArr[a])
                  }
                }
              }
              for (var i = 0; i < this.platformData[4].data.length; i++) {
                for (var a = 0; a < ddArr2.length; a++) {
                  if (this.platformData[4].data[i].num == ddArr2[a]) {
                    this.checkList.push('dd' + ddArr2[a])
                  }
                }
              }
            }

            // 唯品会优惠券回显
            if (res.data.weipinhui) {
              wphArr = res.data.weipinhui.split(",")
              for (var i = 0; i < this.platformData[5].data.length; i++) {
                for (var a = 0; a < wphArr.length; a++) {
                  if (this.platformData[5].data[i].num == wphArr[a]) {
                    this.checkList.push('wph' + wphArr[a])
                  }
                }
              }
            }

            // 药房网优惠券回显
            if (res.data.yaofangwang) {
              yfwArr = res.data.yaofangwang.split(",")
              console.log(yfwArr)
              for (var i = 0; i < this.platformData[6].data.length; i++) {
                for (var a = 0; a < yfwArr.length; a++) {
                  if (this.platformData[6].data[i].num == yfwArr[a]) {
                    this.checkList.push('yfw' + yfwArr[a])
                  }
                }
              }
            }
            console.log(res.data.yaofangwang)
            console.log(res.data.yiyaocheng)
            console.log(this.platformData)
            // 1药城优惠券回显
            if (res.data.yiyaocheng) {
              yycArr = res.data.yiyaocheng.split(",")
              for (var i = 0; i < this.platformData[7].data.length; i++) {
                for (var a = 0; a < yycArr.length; a++) {
                  if (this.platformData[7].data[i].num == yycArr[a]) {
                    this.checkList.push('yyc' + yycArr[a])
                  }
                }
              }
            }
            console.log(this.checkList)
            this.reducedCalculate = res.data.reducedCalculate.toString()
            this.categoryManagement = res.data.categoryManagement.toString()
            
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        }).catch(err => {
          // this.$message.error('接口异常');
        });
      },
      checkboxChange() {
        this.taobao = []
        this.jingdong = []
        this.suning = []
        this.pinduoduo = []
        this.dangdang = []
        this.weipinhui = []
        this.yaofangwang = []
        this.yiyaocheng = []

        // 淘宝已选优惠价处理
        if (this.checkList.length > 0) {
          for (var i = 0; i < this.checkList.length; i++) {
            if (this.checkList[i].indexOf("tbtm") != -1) {
              this.taobao.push(this.checkList[i].substring(4,5))
            }
          }
        }
        // 京东已选优惠价处理
        if (this.checkList.length > 0) {
          for (var i = 0; i < this.checkList.length; i++) {
            if (this.checkList[i].indexOf("jd") != -1) {
              this.jingdong.push(this.checkList[i].substring(2,3))
            }
          }
        }
        // 苏宁已选优惠价处理
        if (this.checkList.length > 0) {
          for (var i = 0; i < this.checkList.length; i++) {
            if (this.checkList[i].indexOf("sn") != -1) {
              this.suning.push(this.checkList[i].substring(2,3))
            }
          }
        }
        // 拼多多已选优惠价处理
        if (this.checkList.length > 0) {
          for (var i = 0; i < this.checkList.length; i++) {
            if (this.checkList[i].indexOf("pdd") != -1) {
              this.pinduoduo.push(this.checkList[i].substring(3,4))
            }
          }
        }
        // 当当已选优惠价处理
        if (this.checkList.length > 0) {
          for (var i = 0; i < this.checkList.length; i++) {
            if (this.checkList[i].indexOf("dd") == 0) {
              this.dangdang.push(this.checkList[i].substring(2,3))
            }
          }
        }
        // 唯品会已选优惠价处理
        if (this.checkList.length > 0) {
          for (var i = 0; i < this.checkList.length; i++) {
            if (this.checkList[i].indexOf("wph") == 0) {
              this.weipinhui.push(this.checkList[i].substring(3,4))
            }
          }
        }
        // 药房网已选优惠价处理
        if (this.checkList.length > 0) {
          for (var i = 0; i < this.checkList.length; i++) {
            if (this.checkList[i].indexOf("yfw") == 0) {
              this.yaofangwang.push(this.checkList[i].substring(3,4))
            }
          }
        }
        // 1药城已选优惠价处理
        if (this.checkList.length > 0) {
          for (var i = 0; i < this.checkList.length; i++) {
            if (this.checkList[i].indexOf("yyc") == 0) {
              this.yiyaocheng.push(this.checkList[i].substring(3,4))
            }
          }
        }
        // 更新
        let params={}
        if (this.taobao.join(',')) {
          params.taobao = this.taobao.join(',')
        } else {
          params.taobao = '0'
        }
        if (this.jingdong.join(',')) {
          params.jingdong = this.jingdong.join(',')
        } else {
          params.jingdong = '0'
        }
        if (this.suning.join(',')) {
          params.suning = this.suning.join(',')
        } else {
          params.suning = '0'
        }
        if (this.pinduoduo.join(',')) {
          params.pinduoduo = this.pinduoduo.join(',')
        } else {
          params.pinduoduo = '0'
        }
        if (this.dangdang.join(',')) {
          params.dangdang = this.dangdang.join(',')
        } else {
          params.dangdang = '0'
        }
        if (this.weipinhui.join(',')) {
          params.weipinhui = this.weipinhui.join(',')
        } else {
          params.weipinhui = '0'
        }
        if (this.yaofangwang.join(',')) {
          params.yaofangwang = this.yaofangwang.join(',')
        } else {
          params.yaofangwang = '0'
        }
        if (this.yiyaocheng.join(',')) {
          params.yiyaocheng = this.yiyaocheng.join(',')
        } else {
          params.yiyaocheng = '0'
        }
        params.reducedCalculate = Number(this.reducedCalculate)
        fetch({
          url: "hcm/cus/updateCoupons",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: '保存成功',
              type: 'success'
            });
            this.taobao = []
            this.jingdong = []
            this.suning = []
            this.pinduoduo = []
            this.dangdang = []
            this.weipinhui = []
            this.yaofangwang = []
            this.yiyaocheng = []

            this.selectbmcSetting()
          } else {
            this.$message.error(response.data.message)
          }
        }).catch(err => {
          // this.$message.error('接口异常');
          this.selectbmcSetting()
        });
      },
    },
  }
</script>

<style lang="scss">
#preferentialSettings {
  .el-checkbox-group {
    display: contents;
  }
  .titleStyle {
    background-color: #f6f7fb;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 5px;
    padding-left: 20px;
  }
}
</style>
